import { MathUtils, Mesh } from "three";
import { mainScene } from "@modules/rendering/mainScene";
import { camera } from "@modules/rendering/camera";
import { localPlayerContainer } from "@modules/localplayer/LocalPlayerContainer";
import { Vector3 } from "flavr-math";
export function getNumMatrixAutoUpdate() {
    let numMatrixAutoUpdate = 0;
    mainScene.traverse((node) => {
        if (node.matrixAutoUpdate)
            numMatrixAutoUpdate++;
    });
    return numMatrixAutoUpdate;
}
export function getNumVisibleObjectsAndMeshes() {
    let numVisibleObjects = 0;
    let numVisibleMeshes = 0;
    mainScene.traverseVisible((node) => {
        if (node instanceof Mesh)
            numVisibleMeshes++;
        numVisibleObjects++;
    });
    return { objects: numVisibleObjects, meshes: numVisibleMeshes };
}
export function getCameraPositionString() {
    const camPos = camera.perspectiveCam.getWorldPosition(new Vector3());
    return `${camPos.x.toFixed(2)} / ${camPos.y.toFixed(2)} / ${camPos.z.toFixed(2)}`;
}
export function getVirtualPlatformPositionString() {
    const rootPos = localPlayerContainer.getPosition(new Vector3());
    return `${rootPos.x.toFixed(2)} / ${rootPos.y.toFixed(2)} / ${rootPos.z.toFixed(2)}`;
}
export function getCameraRotationString() {
    const vector = camera.perspectiveCam.getWorldDirection(new Vector3());
    const yaw = Math.atan2(vector.x, vector.z);
    const pitch = Math.asin(vector.y);
    return `${MathUtils.radToDeg(pitch).toFixed(2)} ${MathUtils.radToDeg(yaw).toFixed(2)} (pitch, yaw)`;
}
